<template>
  <v-container fluid fill-height>
    <v-layout :class="($isMobile() ? '' : 'align-center') + ' justify-center'">
      <v-flex xs12 sm8 md4>
        <v-img :src="require('@/assets/img/logo.png')" height="90" contain />

        <p class="login-title">{{ SITE_NAME }}</p>
        <v-card class="elevation-12">
          <v-card-text class="pa-0">
            <v-tabs-items v-model="tab">
              <v-tab-item class="pa-4">
                <v-form data-vv-scope="emailform">
                  <v-text-field
                    :name="`email_${Date.now() + Math.random()}`"
                    v-model="email"
                    prepend-icon="person"
                    :label="$t('auth.email')"
                    class="required-field"
                    v-validate="'required'"
                    :error-messages="errors.collect('emailform.email')"
                    data-vv-name="emailform.email"
                    type="text"
                    @keydown="checkKeyPress"
                    placeholder=" "
                  ></v-text-field>
                  <v-text-field
                    :name="`password_${Date.now() + Math.random()}`"
                    v-model="password"
                    prepend-icon="lock"
                    :label="$t('auth.password')"
                    class="required-field"
                    v-validate="'required'"
                    :error-messages="errors.collect('emailform.password')"
                    data-vv-name="emailform.password"
                    type="password"
                    @keydown="checkKeyPress"
                    persistent-hint
                    placeholder=" "
                  ></v-text-field>

                  <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                      <v-flex xs6>
                        <router-link :to="'/auth/' + locale + '/forgot?type=email'" xs6 class="text-left d-block mt-5">
                          {{ $t("auth.forgot.forgot") }}
                        </router-link>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn text color="primary" class="float-right mt-5 mr-0 pr-0" @click="show_policy = true">{{
                          $t("global.privacy_policy_link")
                        }}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-tab-item>
              <v-tab-item class="pa-4">
                <v-form data-vv-scope="mobileform">
                  <vue-tel-input-vuetify
                      class="required-field"
                      v-validate="'required'"
                      :label="$t('auth.mobile')"
                      v-model="mobile"
                      @input="
                        (formattedNumber, { number, valid, country }) => {
                          mobile = number.significant || formattedNumber
                          mobile_code = country.dialCode || null
                        }
                      "
                      placeholder=""
                      data-vv-name="mobileform.mobile"
                      :error-messages="errors.collect('mobileform.mobile')"
                      defaultCountry="NO"
                      @keydown="checkKeyPress"
                    ></vue-tel-input-vuetify>

                  <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                      <v-flex xs6>
                        <router-link :to="'/auth/' + locale + '/forgot?type=mobile'" xs6 class="text-left d-block mt-5">
                          {{ $t("auth.forgot.forgot") }}
                        </router-link>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn text color="primary" class="float-right mt-5 mr-0 pr-0" @click="show_policy = true">{{
                          $t("global.privacy_policy_link")
                        }}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-tab-item>
              <v-tab-item class="pa-4">
                <action-button type="default" color="error" :text="$t('auth.login_feide')" class="d-block" @click="feideLogin" />

                <v-container fluid fill-height class="pa-0">
                  <v-layout align-center justify-center>
                    <v-flex xs6> </v-flex>

                    <v-flex xs6>
                      <v-btn text color="primary" class="float-right mt-5 mr-0 pr-0" @click="show_policy = true">{{
                        $t("global.privacy_policy_link")
                      }}</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-layout align-center justify-center>
              <v-flex xs12>
                <action-button
                  type="default"
                  @click="login"
                  :text="this.$t('auth.login')"
                  color="primary"
                  class="login-btn primary ma-0"
                  :icon_only_xs="false"
                />
              </v-flex>
              <v-flex xs12>
                <v-menu transition="slide-y-transition" offset-y
                  ><template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="info" class="cstm-v-btn login-btn darken-2">
                      <span class="cstm-v-btn-text pl-0">{{ $t("auth.register") }}</span>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="register(item.key)" v-for="(item, i) in this.$dd_register_type()" :key="i">
                      <v-list-item-content>{{ item.text }}</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>

        <v-btn color="info" class="cstm-v-btn login-option-btn d-block mt-4 ml-0" @click="tab = 0">
          <v-icon left>far fa-envelope</v-icon>{{ $t("auth.login_email") }}
        </v-btn>
        <v-btn color="warning" class="cstm-v-btn login-option-btn d-block mt-2 ml-0" @click="tab = 1">
          <v-icon left>fas fa-mobile-alt</v-icon>{{ $t("auth.login_mobile") }}
        </v-btn>
        <v-btn color="error" class="cstm-v-btn login-option-btn d-block mt-2 ml-0" @click="tab = 2">
          <v-avatar tile size="24" class="mr-2">
            <v-img :src="require('@/assets/img/feide_logo_white_small.png')" aspect-ratio="1"></v-img>
          </v-avatar>
          {{ $t("auth.login_feide") }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showEnterSMSCode" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-app-bar dark color="primary">
          {{ $t("auth.sms_code") }}
        </v-app-bar>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <p>{{ $t("auth.enter_code_sms", { mobile: $formatPhoneNumber(mobile, mobile_code) }) }}</p>
          <v-flex xs12>
            <v-text-field name="sms_code" v-model="sms_code" :label="$t('auth.enter_code')" autocomplete="new-password"></v-text-field>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <action-button type="cancel" @click="closeSMSCodeDialog()" />
          <action-button type="default" color="info" :text="resend_status && resend_timer > 0 ? `${$t('global.resend_in')} ${resend_timer}` : $t('global.resend')" icon="fas fa-sms" @click="resendSMSCode()" :disabled="Boolean(resend_status)" />
          <action-button type="validate" @click="validateSMSCode" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSetPassword" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-app-bar dark color="primary">
          {{ $t("auth.set_password") }}
        </v-app-bar>
        <v-divider></v-divider>
        <v-card-text>
            <v-form data-vv-scope="setpasswordform">
              <v-flex xs12>
                <v-text-field
                  data-vv-name="setpasswordform.new_password"
                  prepend-icon="lock"
                  v-model="new_password"
                  class="required-field"
                  v-validate="'required|password_strength'"
                  :label="$t('auth.new_password')"
                  :error-messages="errors.collect('setpasswordform.new_password')"
                  type="password"
                  ref="setpasswordform.new_password"
                  :hint="$t('global.helptext_password')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  data-vv-name="setpasswordform.new_password_retype"
                  prepend-icon="lock"
                  v-model="new_password_retype"
                  class="required-field"
                  v-validate="'required|confirmed:setpasswordform.new_password|password_strength'"
                  :label="$t('auth.new_password_retype')"
                  :error-messages="errors.collect('setpasswordform.new_password_retype')"
                  type="password"
                  :hint="$t('global.helptext_password')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-form>
          </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
            <action-button type="default" :text="$t('auth.update_password')" @click="setPassword" :icon_only_xs="false" />
            <action-button type="cancel" @click="cancelSetPassword" :icon_only_xs="false" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <pinCode :show="show_pincode" @callback_pincode_submit="callback_pincode_submit" @callback_pincode_cancel="show_pincode = false" />
    <privacyPolicy :show="show_policy" :locale="locale" @callback_privacy_cancel="show_policy = false" />
  </v-container>
</template>

<script>
import pinCode from "@/modules/auth/partials/PinCode"
import privacyPolicy from "@/themes/partials/shared/Privacy"
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "login",

  props: ["locale"],

  components: {
    pinCode,
    privacyPolicy,
    VueTelInputVuetify
  },

  data() {
    return {
      id: null,
      email: "",
      password: "",
      mobile: "",
      mobile_code: "",
      tab: 1,

      resend_second: 15,
      resend_status: false,
      resend_timer: 0,

      register_type: {
        user: this.$t("auth.register_type_user"),
        company: this.$t("auth.register_type_company")
      },
      show_pincode: false,
      pinObj: {},

      showEnterSMSCode: false,
      sms_code: null,
      sms_uuid: null,

      show_policy: false,

      showSetPassword: false,
      new_password: "",
      new_password_retype: "",
      setPasswordUserID: null,

      dictionary: {
        attributes: {
          "emailform.email": this.$t("auth.email"),
          "emailform.password": this.$t("auth.password"),
          "mobileform.mobile": this.$t("auth.mobile"),
          "setpasswordform.new_password": this.$t("auth.new_password"),
          "setpasswordform.new_password_retype": this.$t("auth.new_password_retype")
        }
      }
    }
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  created() {
    let vm = this
    let user = localStorage.getItem("__crrntUser")

    this.$updateSetting("fe_locale", this.computedLocale)
    this.$i18n.locale = this.computedLocale

    this.mobile_code = "47"

    if (user) {
      if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
        vm.$router.push(vm.BACKEND_URL + "/dashboard")
      } else {
        vm.$router.push(vm.BACKEND_URL + "/my")
      }
    } else {
      if (vm.$isMobile()) {
        vm.$store.dispatch("auth/getPinCode").then((result) => {
          if (result) {
            this.pinObj = result

            if (this.pinObj.login_via_pin) {
              this.show_pincode = true
            }
          }
        })
      }
    }
  },

  computed: {
    computedLocale() {
      return this.locale
    }
  },

  methods: {
    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.login()
      }
    },

    login() {
      let vm = this

      if (this.tab == 0) {
        // Email
        this.$validator
          .validateAll("emailform")
          .then((valid) => {
            if (valid) {
              axios
                .post(this.API_URL + "auth/login", {
                  email: vm.email,
                  password: vm.password,
                  type: "password"
                })
                .then((res) => {
                  this.postLogin(res.data)
                })
                .catch((err) => console.log(err))
            }
          })
          .catch(() => {})
      } else {
        // Mobile
        this.$validator
          .validateAll("mobileform")
          .then((valid) => {
            if (valid) {
              this.openSMSCodeDialog()
            }
          })
          .catch(() => {})
      }
    },
    mobileLogin(id, token) {
      axios
        .post(this.API_URL + "auth/loginUser", {
          id: id,
          token: token,
          type: "mobile"
        })
        .then((res) => {
          this.postLogin(res.data)
        })
        .catch((err) => console.log(err))
    },
    postLogin(data) {
      let vm = this
      let token = data.access_token
      let user = data.user_data

      if (token && user && (user.status == 1 || user.status == 3)) {
        let status = user.status
        let locale = "no"

        this.$cookies.set(`${this.COOKIE_PREFIX}access_token`, token)
        vm.$setAuthorization(token)
        vm.$init(token, user)

        let localesetting = user.settings.find((i) => i.key == "locale")
        if (localesetting && localesetting.value) {
          locale = localesetting.value
        }

        this.$updateSetting("fe_locale", locale)
        this.$updateSetting("locale", locale)
        this.$i18n.locale = locale

        if (status == 1) {
          // After login redirects
          if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
            vm.$router.push(vm.BACKEND_URL + "/dashboard")
          } else {
            vm.$router.push(vm.BACKEND_URL + "/my")
          }
        } else if (status == 3) {
          this.$router.push("/auth/" + locale + "/forcechangepassword")
        }
      } else {
        vm.$awn.alert(vm.$t("auth.login_error"))
      }
    },
    register(type) {
      this.$router.push("/auth/" + this.computedLocale + "/register/" + type)
    },

    // PIN CODE
    callback_pincode_submit(pin) {
      let vm = this

      this.bcrypt.compare(pin, this.pinObj.hash, (err, res) => {
        if (res) {
          axios
            .post(this.API_URL + "auth/login", {
              id: this.pinObj.userid,
              type: "pin"
            })
            .then((res) => {
              vm.postlogin(res)
            })
            .catch((err) => console.log(err))
        } else {
          vm.$awn.alert(vm.$t("auth.login_error"))
        }
      })
    },
    callback_pincode_cancel() {
      this.id = null
      this.show_pincode = false
    },
    showSetPinCode(id) {
      this.id = id
      this.show_pincode = true
    },

    // SMS OTP
    openSMSCodeDialog() {
      axios
        .post(this.API_URL + "smsotp/generate", {
          type: "login-mobile",
          number: this.$formatPhoneNumber(this.mobile, this.mobile_code)
        })
        .then((res) => {
          let status = res.data.status

          if (status == "ok") {
            this.showEnterSMSCode = true
            this.sms_uuid = res.data.uuid
          } else {
            let message = res.data.message || this.$t("auth.sms_otp_send_failed")
            this.$awn.alert(message)
          }
        })
        .catch((err) => console.log(err))
    },
    validateSMSCode() {
      axios
        .post(this.API_URL + "smsotp/validate", {
          type: "login-mobile",
          uuid: this.sms_uuid,
          code: this.sms_code
        })
        .then((res) => {
          let status = res.data.status
          let type = res.data.type

          if (status == "ok") {
            this.closeSMSCodeDialog()

            if (type == "login-mobile") {
              var userid = res.data.param_userid
              var usertoken = res.data.param_usertoken
              var usersetpassword = res.data.param_user_setpassword

              if(usersetpassword) {
                this.openSetPassword(userid, usertoken)
              } else {
                this.mobileLogin(userid, usertoken) 
              }
            }
          } else {
            let message = res.data.message || this.$t("auth.sms_otp_incorrect_code")
            this.$awn.alert(message)
          }
        })
        .catch((err) => console.log(err))
    },
    resendSMSCode() {
      let vm = this

      axios
        .post(this.API_URL + "smsotp/resend", {
          uuid: this.sms_uuid,
          type: "login-mobile",
          number: this.$formatPhoneNumber(this.mobile, this.mobile_code)
        })
        .then((res) => {
          let status = res.data.status

          if (status == "ok") {
            this.sms_uuid = res.data.uuid
            this.resend_status = true
            this.resend_timer = this.resend_second

            let timer = setInterval(() => {
              vm.resend_timer = vm.resend_timer - 1
              console.log("Resend in " + vm.resend_timer)
              if(vm.resend_timer == 0) {
                vm.resend_status = false
                clearInterval(timer)
                console.log("Resend enabled")
              }
            }, 1000)

          } else {
            let message = res.data.message || this.$t("auth.sms_otp_send_failed")
            this.$awn.alert(message)
          }
        })
        .catch((err) => console.log(err))
    },
    closeSMSCodeDialog() {
      this.showEnterSMSCode = false
      this.sms_code = null
      this.sms_uuid = null
    },

    //FEIDE
    feideLogin() {
      axios
        .get(this.API_URL + "auth/feide/getAuthorizationRequestURL")
        .then((res) => {
          if (res.status == 200) {
            window.location.href = res.data.url
          }
        })
        .catch((err) => {
          this.$awn.alert(this.$t("auth.error_feide_invalid_authorization_url"))
        })
    },

    // MOBILE SET PASSWORD
    setPassword() {
      let vm = this

      this.$validator
          .validateAll("setpasswordform")
          .then((valid) => {
            if (valid) {
              axios
                .post(this.API_URL + "auth/password/update-only", {
                  id: vm.setPasswordUserID,
                  new_password: vm.new_password,
                })
                .then((res) => {
                  this.mobileLogin(vm.setPasswordUserID, vm.setPasswordUserToken)
                })
                .catch((err) => console.log(err))
            }
          })
          .catch(() => {})
    },
    openSetPassword(user_id, token) {
      this.showSetPassword = true
      this.setPasswordUserID = user_id
      this.setPasswordUserToken = token
    },
    cancelSetPassword() {
      this.showSetPassword = false
      this.new_password = ""
      this.new_password_retype = ""
      this.setPasswordUserID = null
      this.setPasswordUserToken = null
    }
  }
}
</script>

<style>
.login-option-btn {
  font-size: 0.9rem !important;
}
</style>
